// extracted by mini-css-extract-plugin
export var followUs = "styles-module--followUs--WeIVP";
export var followUsIcon = "styles-module--followUsIcon--0-7Zu";
export var followUsLink = "styles-module--followUsLink--0nmeN";
export var gridContainer = "styles-module--gridContainer--Pksk8";
export var instagramContainer = "styles-module--instagramContainer--xZq5f";
export var link = "styles-module--link--WrftH";
export var title = "styles-module--title--Xg-bq";